import { InputFieldCombinedProps } from './types';

const usePresenter = (props: InputFieldCombinedProps): InputFieldCombinedProps => {
  return props;
};

export default usePresenter;
